import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Container,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { FaOilCan, FaCarCrash, FaVideo, FaCloudRain, FaLightbulb, FaCarBattery, FaChevronDown } from 'react-icons/fa';
import { BiSolidCarWash } from 'react-icons/bi';
import { GiCartwheel, GiMagnifyingGlass } from "react-icons/gi";
import logo from './assets/Logo.png';
import ReviewSummary from './ReviewSummary';
import './LandingPage.css';

function ServiceCards({ cards, onCardClick }) {
  return (
    <Container maxWidth="lg">
      <div className="ring-container">
        <div className="ring-cards">
          {cards.map((card, index) => (
            <Paper
              key={index}
              className="ring-card"
              style={{ '--rotate-y': card.rotateY }}
              onClick={onCardClick}  // افزودن رویداد کلیک
            >
              <div className="ring-icon">{card.icon}</div>
              <Typography variant="h6">{card.title}</Typography>
              <Typography variant="body2">{card.text}</Typography>
            </Paper>
          ))}
        </div>
      </div>
    </Container>
  );
}

function LandingPage() {
  const navigate = useNavigate();
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewSummary, setReviewSummary] = useState({ average: 0, count: 0 });
 const [modalOpen, setModalOpen] = useState(false);  // state برای کنترل دیالوگ

  useEffect(() => {
    document.body.classList.add('landing-page');

    fetch("https://carcure.ca/backend/get-review-summary")
      .then(res => res.json())
      .then(data => setReviewSummary(data))
      .catch(err => console.error(err));

    return () => {
      document.body.classList.remove('landing-page');
    };
  }, []);

  const renderStarsHeader = (average) => {
    const fullStars = Math.floor(average);
    const halfStar = average - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
    const stars = [];
    for (let i = 0; i < fullStars; i++) stars.push('★');
    if (halfStar) stars.push('☆');
    for (let i = 0; i < emptyStars; i++) stars.push('✩');
    return <span className="stars">{stars.join('')}</span>;
  };


 // تابعی برای باز کردن دیالوگ در صفحات کوچک
  const handleCardClick = () => {
    if (window.innerWidth <= 768) {
      setModalOpen(true);
    }
  };


  const cards = [
    { icon: <FaOilCan />, rotateY: '0deg', title: 'Oil & Filter Change', text: 'Keep your engine running smoothly with fresh oil and filter replacement.' },
    { icon: <GiCartwheel />, rotateY: '40deg', title: 'Flat Tire Repair', text: 'Fix tires on the spot and continue your journey safely.' },
    { icon: <FaCarCrash />, rotateY: '80deg', title: 'Brake Pad & Inspection', text: 'Ensure efficient braking with new brake pads and a full wheel check-up.' },
    { icon: <FaVideo />, rotateY: '120deg', title: 'DashCam Installation', text: 'Enhance your vehicle’s security with a professionally installed DashCam.' },
    { icon: <FaCloudRain />, rotateY: '160deg', title: 'Wiper Blade Replacement', text: 'Improve visibility in rainy conditions with brand-new wiper blades.' },
    { icon: <GiMagnifyingGlass />, rotateY: '200deg', title: 'Full Vehicle Inspection', text: 'Get a detailed fault detection for your car’s optimal performance.' },
    { icon: <BiSolidCarWash />, rotateY: '240deg', title: 'Car Wash & Detailing', text: 'Enjoy a thorough wash and interior cleaning to keep your car spotless.' },
    { icon: <FaLightbulb />, rotateY: '280deg', title: 'Headlight & Lamp Service', text: 'Replace or install headlights, projectors, and lamps with proper alignment for safer night driving.' },
    { icon: <FaCarBattery />, rotateY: '320deg', title: 'Battery Test & Replacement', text: 'Check battery health for reliable starts, and replace with a new one if needed.' },
  ];

  return (
    <div className="landing-page">
      <header className="header">
        <img src={logo} alt="CarCure Logo" className="header-logo" />
        <div className={`header-review-summary ${reviewOpen ? "open" : ""}`} onClick={() => setReviewOpen(prev => !prev)}>
          <span className="summary-text">
            Average Rating: {renderStarsHeader(reviewSummary.average)} {parseFloat(reviewSummary.average).toFixed(1)} ({reviewSummary.count})
          </span>
          <FaChevronDown className="arrow-icon" />
        </div>
      </header>
      
      {reviewOpen && (
        <div className="review-details-panel">
          <ReviewSummary hideHeader={true} />
        </div>
      )}

      <div className="content-container">
        <div className="top-text-box">
          <Typography variant="h4" className="top-title">
            🚗 Car Services at Your Location
          </Typography>
        </div>

        <div className="services-section">
<ServiceCards cards={cards} onCardClick={handleCardClick} />
        </div>

        <div className="cta-box">
          <Typography variant="h6" className="cta-text">
            Fast, Reliable, and Professional! Book your car services without visiting a workshop.
          </Typography>
          <div className="buttons">
            <Button variant="contained" color="primary" size="large" onClick={() => navigate('/register')}>
              🚀 Sign Up
            </Button>
            <Button variant="contained" color="primary" size="large" onClick={() => navigate('/login')}>
              🔑 Log In
            </Button>
          </div>
<div className="contact-section">
  <Typography variant="body1">
       Contact us: <a href="tel:+1234567890"> (705) 991-2321</a> | <a href="mailto:info@carcure.ca">info@carcure.ca</a>
  </Typography>
</div>
</div>
</div>

  {/* دیالوگ نمایش پیام در صفحات کوچک */}
<Dialog
  open={modalOpen}
  onClose={() => setModalOpen(false)}
  PaperProps={{
    className: "custom-dialog"
  }}
  BackdropProps={{
    className: "custom-backdrop"
  }}
>
  <DialogTitle className="custom-dialog-title">Sign In Required</DialogTitle>
  <DialogContent>
    <DialogContentText className="custom-dialog-content-text">
 	 Dear customer,<br /><br />
  	To serve you better and ensure a personalized experience, we kindly invite you to sign in or log in.<br /><br />
  	Your satisfaction is our top priority.
   </DialogContentText>

  </DialogContent>
  <DialogActions className="custom-dialog-action">
  <Button onClick={() => setModalOpen(false)} className="custom-close-button">
    Close
  </Button>
</DialogActions>
</Dialog>



    </div>
  );
}

export default LandingPage;
